export default "__VITE_ASSET__DXLpFtyo__"